module.exports = __webpack_public_path__ + "img/b5-2.b7dbe34.png";